import React, { useState, useEffect, useRef } from 'react';
import { Box, Card, Stepper, Step, StepLabel, Typography, Grid, Chip } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import VishingStep1 from './vishing/vishingStep1';
import VishingStep2 from './vishing/vishingStep2';
import VishingStep3 from './vishing/vishingStep3';
import VishingStep4 from './vishing/vishingStep4';
import { fetchScenarios, saveCampaign, startCalls } from './vishing/api';
import { steps } from './vishing/constants';

import AssignmentIcon from '@mui/icons-material/Assignment';
import PhoneInTalkIcon from '@mui/icons-material/PhoneInTalk';
import TuneIcon from '@mui/icons-material/Tune';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import CampaignIcon from '@mui/icons-material/Campaign';

import { alpha, darken } from '@mui/material/styles';
import { BASEURL, PRIMARYCOLOR } from '../../Constants';

// --- Header style to match External/Dark Web ---
const HeaderCard = styled(Card)(({ theme }) => ({
  width: '100%',
  maxWidth: 1100,
  marginBottom: theme.spacing(4),
  padding: theme.spacing(3),
  borderRadius: 16,
  background: `linear-gradient(135deg, ${PRIMARYCOLOR} 0%, ${darken(PRIMARYCOLOR,0.5)} 100%)`,
  color: '#fff',
  boxShadow: '0 10px 30px rgba(0,0,0,0.15)'
}));

const StepIconContainer = styled('div')(({ theme, ownerState }) => ({
  backgroundColor: ownerState.active
    ? theme.palette.primary.main
    : ownerState.completed
    ? theme.palette.success.main
    : theme.palette.grey[300],
  color: '#fff',
  width: 36,
  height: 36,
  borderRadius: '50%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  boxShadow: ownerState.active ? '0 0 0 6px rgba(25,118,210,0.15)' : 'none'
}));

function CustomStepIcon(props) {
  const { active, completed, icon } = props;
  const mapping = {
    1: <AssignmentIcon fontSize="small" />, // Details
    2: <PhoneInTalkIcon fontSize="small" />, // Scope / Calls
    3: <TuneIcon fontSize="small" />, // Configure / Review
    4: <EmojiEventsIcon fontSize="small" /> // Done
  };
  return (
    <StepIconContainer ownerState={{ active, completed }}>
      {mapping[icon] || <AssignmentIcon fontSize="small" />}
    </StepIconContainer>
  );
}

const CreateVishingPentest = () => {
  const [activeStep, setActiveStep] = useState(0);
  const [projectName, setProjectName] = useState('');
  const [organizationId, setOrganizationId] = useState(-1);
  const [organizations, setOrganizations] = useState([{ id: -1, name: 'None' }]);
  const [vishingScope, setVishingScope] = useState([]);
  const [companyName, setCompanyName] = useState('');
  const [companyDetails, setCompanyDetails] = useState('');
  const [recordDisclosureEnabled, setRecordDisclosureEnabled] = useState(false);
  const [voicesData, setVoicesData] = useState([]);
  const [scenariosData, setScenariosData] = useState([]);
  const [campaignId, setCampaignId] = useState('');
  const [campaignError, setCampaignError] = useState('');
  const [callerNumbersRefreshKey, setCallerNumbersRefreshKey] = useState(0);
  const navigate = useNavigate();
  const fileInputRef = useRef();

  const prependNone = (list = []) => {
  const cleaned = (list || []).filter(o => o && Number(o.id) !== -1);
  return [{ id: -1, name: 'None' }, ...cleaned];
};

function loadOrganizationsBasic() {
  const token = sessionStorage.getItem('token');
  if (!token) {
    try { navigate('/'); } catch { /* optional if navigate not available */ }
    return;
  }
  fetch(`${BASEURL}/organizations?basic=1`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  })
    .then(r => r.json())
    .then(data => {
      if (data?.error) {
        console.error(data.message || 'Error fetching organizations (basic)');
        setOrganizations([{ id: -1, name: 'None' }]);
        setOrganizationId(-1);
        return;
      }
      const list = Array.isArray(data?.organizations) ? data.organizations : [];
      setOrganizations(prependNone(list));
      setOrganizationId(-1); // default selection
    })
    .catch(err => {
      console.error('Failed to fetch organizations (basic):', err);
      setOrganizations([{ id: -1, name: 'None' }]);
      setOrganizationId(-1);
    });
}


  useEffect(() => {
    fetchScenarios(setVoicesData, setScenariosData);
    loadOrganizationsBasic();
  }, []);

  const handleFinish = () => {
    startCalls(campaignId);
    navigate('/pentests');
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%', p: { xs: 2, md: 4 } }}>
      {/* Header (matches External/Dark Web) */}
      <HeaderCard>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} md={8}>
            <Typography variant="h4" sx={{ fontWeight: 800, mb: 1 }}>
              Create Vishing Campaign Project
            </Typography>
            <Typography sx={{ opacity: 0.9 }}>
              Spin up voice agents, choose scenarios & voices, and define your call targets.
            </Typography>
          </Grid>
          <Grid item xs={12} md={4} sx={{ textAlign: { xs: 'left', md: 'right' } }}>
            <Chip
              icon={<PhoneInTalkIcon />}
              label="Voice Agents"
              variant="outlined"
              sx={{ borderColor: alpha("#fff", 0.6), color: "white", "& .MuiChip-icon": { color: "#fff" } }}
            />
            <Chip
              icon={<CampaignIcon />}
              label="Social Engineering"
              variant="outlined"
              sx={{ borderColor: alpha("#fff", 0.6), color: "white", "& .MuiChip-icon": { color: "#fff" } }}
            />
          </Grid>
          <Grid item xs={12} sx={{ mt: 1 }}>
            <Stepper activeStep={activeStep} alternativeLabel>
              {steps.map((label, i) => (
                <Step key={i}>
                  <StepLabel StepIconComponent={CustomStepIcon}>
                    <Typography sx={{ color: '#fff' }}>{label}</Typography>
                  </StepLabel>
                </Step>
              ))}
            </Stepper>
          </Grid>
        </Grid>
      </HeaderCard>

      {activeStep === 0 && (
        <VishingStep1
          projectName={projectName}
          setProjectName={setProjectName}
          organizationId={organizationId}
          setOrganizationId={setOrganizationId}
          organizations={organizations}
          onNext={() => setActiveStep(1)}
          onBack={() => navigate(-1)}
        />
      )}

      {activeStep === 1 && (
        <VishingStep2
          vishingScope={vishingScope}
          setVishingScope={setVishingScope}
          scenariosData={scenariosData}
          companyName={companyName}
          setCompanyName={setCompanyName}
          companyDetails={companyDetails}
          setCompanyDetails={setCompanyDetails}
          recordDisclosureEnabled={recordDisclosureEnabled}
          setRecordDisclosureEnabled={setRecordDisclosureEnabled}
          voicesData={voicesData}
          fileInputRef={fileInputRef}
          onBack={() => setActiveStep(0)}
          onNext={() => setActiveStep(2)}
        />
      )}

      {activeStep === 2 && (
        <VishingStep3
          vishingScope={vishingScope}
          setVishingScope={setVishingScope}
          scenariosDataa={scenariosData}
          setScenariosDataa={setScenariosData}
          voicesData={voicesData}
          onBack={() => setActiveStep(1)}
          campaignError={campaignError}
          callerNumbersRefreshKey={callerNumbersRefreshKey}
          onSave={async (scope) => {
            setCampaignError('');
            try {
              const id = await saveCampaign(projectName, companyName, companyDetails, recordDisclosureEnabled, scope, organizationId);
              setCampaignId(id);
              setActiveStep(3);
            } catch (error) {
              const message = error?.message || 'Unable to create the vishing campaign.';
              setCampaignError(message);
              if (message.includes('One or more caller numbers are unavailable for this team')) {
                setCallerNumbersRefreshKey((current) => current + 1);
              }
              throw error;
            }
          }}
        />
      )}

      {activeStep === 3 && (
        <VishingStep4 onFinish={handleFinish} />
      )}
    </Box>
  );
};

export default CreateVishingPentest;
